import React from "react";
import { useRecoilValue } from "recoil";
import { isDefaultBackgroundState } from "../global-state";
import { Paper, Button } from "@mhome/ui";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MenuIcon from "@mui/icons-material/Menu";
import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";

const HorizontalNavigation = ({
  curTab,
  setCurTab,
  history,
  isBottomNavVisible,
  isMdOrLgScreen,
  isChatSidebarVisible,
}) => {
  const isDefaultBackground = useRecoilValue(isDefaultBackgroundState);
  const getComponentBgColor = useComponentBackgroundColor();

  const handleTabChange = (event, newValue) => {
    setCurTab(newValue);
    if (newValue === 0) {
      history.push("/dashboard");
    } else if (newValue === 1) {
      history.push("/automation/list");
    } else if (newValue === 2) {
      history.push("/gallery");
    } else if (newValue === 3) {
      history.push("/menu");
    }
  };

  const navigationItems = [
    { label: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
    { label: "Automation", icon: <AutoModeIcon />, path: "/automation/list" },
    { label: "Inspiration", icon: <AutoAwesomeIcon />, path: "/gallery" },
    { label: "Menu", icon: <MenuIcon />, path: "/menu" },
  ];

  return (
    <Paper
      elevation={0}
      style={{
        position: "fixed",
        bottom: "12px",
        left: "16px",
        right: isMdOrLgScreen && isChatSidebarVisible ? "416px" : "16px",
        zIndex: 10,
        borderRadius: "16px",
        overflow: "hidden",
        transform: isBottomNavVisible ? "translateY(0)" : "translateY(100px)",
        transition: "transform 0.3s ease, right 0.3s ease",
        background: "transparent",
        backgroundColor: "transparent",
        boxShadow: "none",
        border: "none",
      }}
    >
      <div
        style={{
          background: "transparent",
          height: "48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        {navigationItems.map((item, index) => {
          const isSelected = curTab === index;
          return (
            <button
              key={index}
              onClick={() => handleTabChange(null, index)}
              style={{
                minWidth: "50px",
                padding: "4px 0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "2px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                color: isSelected
                  ? "hsl(var(--primary))"
                  : "hsl(var(--muted-foreground))",
              }}
            >
              <div
                style={{
                  fontSize: isSelected ? "22px" : "18px",
                  transition: "font-size 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: isSelected
                    ? "hsl(var(--primary))"
                    : "hsl(var(--muted-foreground))",
                }}
              >
                {item.icon}
              </div>
              <span
                style={{
                  fontSize: isSelected ? "10px" : "8px",
                  transition: "font-size 0.2s ease",
                  lineHeight: 1,
                  color: isSelected
                    ? "hsl(var(--primary))"
                    : "hsl(var(--muted-foreground))",
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </Paper>
  );
};

export default HorizontalNavigation;
